import logger from "../utils/logger";

export interface WorkingDaysApiParams {
    monthYear: string;
    uuid: string;
}
export interface WorkingDaysApiResponse {
    workingDays: number;
    working_days: number;
    sales_tax?: number;
}

export async function getWorkingDaysFromDB(params: WorkingDaysApiParams): Promise<WorkingDaysApiResponse[]> {
    const [year, month] = params.monthYear.split("-");
    let _q = `
        SELECT *
        FROM working_days
        WHERE 1=1
    `;

    if (params.uuid && params.monthYear) {
        _q += `
            AND uuid = '${params.uuid}'
            AND LEFT(month_year, 4) = '${year}'
            AND RIGHT(month_year, 2) = '${month.padStart(2, "0")}'
        `;
    }

    console.log("Query to fetch working days:", _q);

    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["working_days"],
            }),
        });

        let data = await response.json();

        return data;
    } catch (error) {
        logger.error("getWorkingDaysFromDB failed", { params }, error);
        return [];
    }
}
